import { LOCATION_CHANGE } from 'react-router-redux';

import { Action, actionCreator } from 'util/actions';
import { createReducer } from 'util/reducers';

import {
  LOAD_HEADER_SUCCESS,
  LOAD_PLUGINS_ERROR,
  LOAD_PLUGINS_REQUEST,
  LOAD_PLUGINS_SUCCESS,
} from 'modules/loaders';

import { EnablePluginError, EnablePluginResponse } from 'types';

const ENABLE_PLUGIN_RESET = Symbol('ui/ENABLE_PLUGIN_RESET');
const ENABLE_PLUGIN_REQUEST = Symbol('ui/ENABLE_PLUGIN_REQUEST');
const ENABLE_PLUGIN_SUCCESS = Symbol('ui/ENABLE_PLUGIN_SUCCESS');
const ENABLE_PLUGIN_ERROR = Symbol('ui/ENABLE_PLUGIN_ERROR');
const TOGGLE_POWER_UPS_DIRECTORY_NAVIGATION = Symbol(
  'ui/TOGGLE_POWER_UPS_DIRECTORY_NAVIGATION',
);

type EnablePluginResetAction = Action<typeof ENABLE_PLUGIN_RESET, null>;
type EnablePluginRequestAction = Action<typeof ENABLE_PLUGIN_REQUEST, null>;
type EnablePluginSuccessAction = Action<
  typeof ENABLE_PLUGIN_SUCCESS,
  EnablePluginResponse
>;
type EnablePluginErrorAction = Action<
  typeof ENABLE_PLUGIN_ERROR,
  EnablePluginError
>;
type TogglePowerUpsDirectoryNavigation = Action<
  typeof TOGGLE_POWER_UPS_DIRECTORY_NAVIGATION,
  null
>;

export const enablePluginResetAction = actionCreator<EnablePluginResetAction>(
  ENABLE_PLUGIN_RESET,
);
export const enablePluginRequestAction = actionCreator<
  EnablePluginRequestAction
>(ENABLE_PLUGIN_REQUEST);
export const enablePluginSuccessAction = actionCreator<
  EnablePluginSuccessAction
>(ENABLE_PLUGIN_SUCCESS);
export const enablePluginErrorAction = actionCreator<EnablePluginErrorAction>(
  ENABLE_PLUGIN_ERROR,
);
export const togglePowerUpsDirectoryNavigation = actionCreator<
  TogglePowerUpsDirectoryNavigation
>(TOGGLE_POWER_UPS_DIRECTORY_NAVIGATION);

export enum EnablePageStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  FAILED = 'failed',
  SUCCESS = 'success',
}

export interface EnablePageState {
  status: EnablePageStatus;
  error?: string;
}

export interface PluginSearchState {
  query: string;
}

export interface PowerUpsDirectoryState {
  loadingPlugins: boolean;
  loadingHeader: boolean;
  navigationExpanded: boolean;
  enablePage: EnablePageState;
  pluginSearch: PluginSearchState;
}

// Reducer
const initialState: PowerUpsDirectoryState = {
  loadingPlugins: true,
  loadingHeader: true,
  navigationExpanded: false,
  enablePage: {
    status: EnablePageStatus.PENDING,
    error: undefined,
  },
  pluginSearch: {
    query: '',
  },
};

export default createReducer(initialState, {
  [LOAD_HEADER_SUCCESS](state: PowerUpsDirectoryState) {
    return {
      ...state,
      loadingHeader: false,
    };
  },
  [LOAD_PLUGINS_REQUEST](state: PowerUpsDirectoryState) {
    return {
      ...state,
      loadingPlugins: true,
    };
  },
  [LOAD_PLUGINS_SUCCESS](state: PowerUpsDirectoryState) {
    return {
      ...state,
      loadingPlugins: false,
    };
  },
  [LOAD_PLUGINS_ERROR](state: PowerUpsDirectoryState) {
    return {
      ...state,
      loadingPlugins: false,
    };
  },
  [ENABLE_PLUGIN_RESET](state: PowerUpsDirectoryState) {
    return {
      ...state,
      enablePage: {
        status: EnablePageStatus.PENDING,
        error: undefined,
      },
    };
  },
  [ENABLE_PLUGIN_REQUEST](state: PowerUpsDirectoryState) {
    return {
      ...state,
      enablePage: {
        status: EnablePageStatus.IN_PROGRESS,
      },
    };
  },
  [ENABLE_PLUGIN_SUCCESS](state: PowerUpsDirectoryState) {
    return {
      ...state,
      enablePage: {
        status: EnablePageStatus.SUCCESS,
      },
    };
  },
  [ENABLE_PLUGIN_ERROR](
    state: PowerUpsDirectoryState,
    { payload }: EnablePluginErrorAction,
  ) {
    return {
      ...state,
      enablePage: {
        status: EnablePageStatus.FAILED,
        error: payload.error,
      },
    };
  },
  [TOGGLE_POWER_UPS_DIRECTORY_NAVIGATION](state: PowerUpsDirectoryState) {
    return {
      ...state,
      navigationExpanded: !state.navigationExpanded,
    };
  },
  [LOCATION_CHANGE](state: PowerUpsDirectoryState) {
    return {
      ...state,
      navigationExpanded: false,
      enablePage: {
        status: EnablePageStatus.PENDING,
        error: undefined,
      },
    };
  },
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/ui/power-ups-directory.ts